<template>
  <div>
    <!--1. 下载-->
    <div class="mb15" v-for="(item, index) in loadList" :key="index">
      <div class="flex align-items-center mb15">
        <img class="img-box-2" :src="item.icon" alt="" />
        <div class="text1">
          {{ item.title }} <span style="color: #f6350f">*</span>
        </div>
        <div v-if="item.title=='典型案例报送申请表'">
        	 <a-button icon="download" type="link" @click="download" style="color:#9A0B00;font-size:16px;">
      			      申请表模板
    			 </a-button>
        </div>
      </div>
      <div>
        <a-upload
          :file-list="item.fileList"
          :accept="item.accept"
          :remove="(file, fileList) => handleRemove(file, fileList, index)"
          :customRequest="()=>{return}"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList, index, item)
          "
        >
         <!-- item.loading || ((index=='0' || index=='1') && item.fileList.length>0 )" -->
         <!-- item.loading || (index=='0' && item.fileList.length>=2 ) || (index=='1' && item.fileList.length>0 )" -->
          <a-button
            :disabled="
              ($parent &&
                $parent.editInfo &&
                $parent.editInfo.type == 'preview') ||
              item.loading || ((index=='0' || index=='1') && item.fileList.length>0 )"
            :loading="item.loading"
          >
            <a-icon type="upload" /> 上传附件
          </a-button>
        </a-upload>
      </div>
      <div class="text2">{{ item.remarks }}</div>
    </div>
    <div class="big-box flex">
      <div class="submit-btn btn-bg-1" @click="option(1)">上 一 步</div>
      <div  class="submit-btn btn-bg-2" @click="save">保存</div>
      <div  class="submit-btn btn-bg-2" @click="submit">提交</div>
    </div>
  </div>
</template>

<script>
import { fileUp } from '@/api/index';
import { pieviewURL } from "../../utils/request";
export default {
  name: '',
  components: {},
  props: {
    loadList: {
      type: Array,
    },
    oldApplyFiles1: {
      type: Array,
    },
  },
  data() {
    return {
      applyFiles: [],
      loading: false,
      type1: false,
      type2: false,
      type3: false,
      path: process.env.BASE_URL,
      loadList1: [
        // {
        //   title: "数字化典型大案例",
        //   id: 1,
        //   remarks: "注：请上传pdf格式的文件，文件大小不超过100M,仅能上传一个文件。",
        //   accept: ".pdf,.docx",
        //   icon: require("../../assets/images/img24.png"),
        //   fileList: [],
        //   oldFileList: [],
        //   loading: false,
        // },
        {
          title: "数字化典型案例",
          id: 9,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100M,仅能上传一个文件。",
          accept: ".pdf,.docx",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "典型案例报送申请表",
          id: 2,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100M,仅能上传一个文件。",
          accept: ".pdf,.docx",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        // {
        //   title: "佐证材料",
        //   id: 3,
        //   remarks: "注：请上传pdf格式的文件，文件大小不超过200M",
        //   accept: ".pdf,.docx,.xls,.xlsx",
        //   icon: require("../../assets/images/img24.png"),
        //   fileList: [],
        //   oldFileList: [],
        //   loading: false,
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
//	 sessionStorage.removeItem('qbsj');
  },
  mounted() {

  	if(this.oldApplyFiles1.length=='0' && sessionStorage.getItem('qbsj')!=undefined){
  		 let arr=JSON.parse(sessionStorage.getItem('qbsj'));
  		 for (let i = 0; i < this.loadList1.length; i++) {
           arr.applyFiles.map((item1) => {
          if (this.loadList1[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            //  item1.filePath.slice()
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.fileType = item1.fileType;
            newItem.url = pieviewURL + newName;
//          this.loadList1[i].fileList.push(newItem);
            this.loadList[i].fileList.push(newItem);
            this.oldApplyFiles1.push(newApplyFiles);
          }
        });
     }
  	}
//	  console.log(sessionStorage.getItem('qbsj'),this.loadList,this.oldApplyFiles1);
  },
  methods: {
    handleRemove(file, fileList, fileindex) {
      this.applyFiles = this.applyFiles.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.loadList[fileindex].fileList.indexOf(file);
      this.$emit('deleteFile', file);
      const newFileList = this.loadList[fileindex].fileList.slice();
      newFileList.splice(index, 1);
      this.loadList[fileindex].fileList = newFileList;
    },
    beforeUpload(file, fileList, fileindex, item) {
      this.$regFile(file, fileList, fileindex, item);
    },
    handleUpload(fileindex, file) {
      this.loadList[fileindex].loading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('biz', 'linxuan');
      fileUp(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.filePath = res.result.path;
          fileItem.fileType = this.loadList[fileindex].id;
          fileItem.uid = file.uid;
          this.applyFiles.push(fileItem);
          this.$emit('upDataFile', fileItem, fileindex, 1);
          this.loadList[fileindex].loading = false;
//        console.log(fileItem, '上传文件');
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    save(){
    	this.submitLoading = this.loadList.filter((item) => {
        if (item.loading) {
          return item;
        }
      });
      if (this.submitLoading && this.submitLoading.length >= 1) {
        this.$message.warning('文件正在上传，请上传成功后提交');
      } else {
        //下面是判断必填代码
//      console.log(this.loadList,this.applyFiles);
//      if(this.loadList[0].fileList.length==0){
//      	this.$message.error('请上传'+this.loadList[0].title);
//      	 return false;
//      }else if(this.loadList[1].fileList.length==0){
//      	this.$message.error('请上传'+this.loadList[1].title);
//      	 return false;
//      }else if(this.loadList[2].fileList.length==0){
//      	this.$message.error('请上传'+this.loadList[2].title);
//      	return false;
//      }
				if (this.oldApplyFiles1 && this.oldApplyFiles1.length > 0) {
          this.applyFiles = this.applyFiles.concat(this.oldApplyFiles1);
       }
        this.$emit('submit', this.loadList, this.applyFiles,0);
      }
    },
    download(){
    	 window.location.href=this.path+"附件2：申请表.docx";
    },
    submit() {
      this.submitLoading = this.loadList.filter((item) => {
        if (item.loading) {
          return item;
        }
      });
      if (this.submitLoading && this.submitLoading.length >= 1) {
        this.$message.warning('文件正在上传，请上传成功后提交');
      } else {
        //下面是判断必填代码
        // console.log(this.loadList,this.applyFiles);
        // else if(this.loadList[0].fileList.length==1){
        //   this.$message.error('请上传'+this.loadList[0].title+'两个文件');
        //   return false;
        // }else if(this.loadList[0].fileList.length>2){
        //   this.$message.error(this.loadList[0].title+'最多上传两个文件，请删除相应的文件！');
        //   return false;
        // }
        if(this.loadList[0].fileList.length==0){
        	this.$message.error('请上传'+this.loadList[0].title);
        	 return false;
        }else if(this.loadList[1].fileList.length==0){
        	this.$message.error('请上传'+this.loadList[1].title);
        	return false;
        }
				if (this.oldApplyFiles1 && this.oldApplyFiles1.length > 0) {
          this.applyFiles = this.applyFiles.concat(this.oldApplyFiles1);
       }
        this.$emit('submit', this.loadList, this.applyFiles,1);
      }
    },
    option(type) {
      //type === 1 上一步 | type === 2 下一步
      this.loadList.map((item) => {
        let newItem = item.fileList.filter((item1) => {
          if (item.fileList.length != 0 && item1 && item1.fileType == 1) {
            this.type1 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 2
          ) {
            this.type2 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 3
          ) {
            this.type3 = true;
          }
        });
        return newItem;
      });
      if (this.oldApplyFiles1 && this.oldApplyFiles1.length > 0) {
        this.applyFiles = this.applyFiles.concat(this.oldApplyFiles1);
      }
      if (type === 1) {
        this.$emit('upStep', this.loadList, this.applyFiles);
      } else {
        this.$emit('downStep', this.loadList, this.applyFiles);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #9A0B00;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 500px;
 margin: 100px  auto 0px;
}
</style>
